import { __awaiter, __generator } from "tslib";
var Environment = /** @class */ (function () {
    function Environment() {
        this._stage = 'dev';
        this._paymentId = '';
    }
    Object.defineProperty(Environment.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        set: function (stage) {
            this._stage = stage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Environment.prototype, "url", {
        get: function () {
            return (this.stage === 'live') ? 'https://payment-api-app.variocube.com' : 'https://payment-api-dev.variocube.com';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Environment.prototype, "paymentId", {
        get: function () {
            return this._paymentId;
        },
        set: function (id) {
            this._paymentId = id;
        },
        enumerable: false,
        configurable: true
    });
    return Environment;
}());
export var env = new Environment();
export function retrievePayment(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function listPaymentMethods(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/payment-methods")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function fetchStripeClientSecret(id, useStoredMethodId) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/stripe-client-secret", {
                        method: 'post',
                        body: JSON.stringify({ useStoredMethodId: useStoredMethodId })
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function saveStripePaymentMethod(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/save-stripe-payment-method", {
                        method: 'post'
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function fetchPaypalOrderId(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/paypal-order", {
                        method: 'post'
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function capturePaypalOrder(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/paypal-capture", {
                        method: 'post'
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function getPayeeName(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/payee-name")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
export function getPayeeCountry(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(env.url + "/public/" + id + "/payee-country")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, getJsonResult(response)];
            }
        });
    });
}
function request(info, init) {
    return __awaiter(this, void 0, void 0, function () {
        var response, message, error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, window.fetch(info, init)];
                case 1:
                    response = _b.sent();
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    message = error_1.message;
                    return [3 /*break*/, 3];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    _a = (_b.sent()).message;
                    if (_a) return [3 /*break*/, 6];
                    return [4 /*yield*/, response.text()];
                case 5:
                    _a = (_b.sent());
                    _b.label = 6;
                case 6:
                    message = _a;
                    throw new Error((message) ? message : "Failed to fetch resource, server returns status " + response.status + ".");
            }
        });
    });
}
function getJsonResult(response) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=request.js.map